import { render } from "./MobileFooter.vue?vue&type=template&id=18edd360&scoped=true&ts=true"
import script from "./MobileFooter.vue?vue&type=script&lang=ts"
export * from "./MobileFooter.vue?vue&type=script&lang=ts"

import "./MobileFooter.vue?vue&type=style&index=0&id=18edd360&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18edd360"]])

export default __exports__